import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { PatientPrescriptionItem } from "./PatientPrescriptionItem";

class PatientPrescriptionListItem implements ITableDataSourceItem<PatientPrescriptionItem> {
    public Model: PatientPrescriptionItem;
    public Name: string;
    public PrescriptionDate: Date;

    constructor(model: PatientPrescriptionItem) {
        this.Model = model;
    }
}

export { PatientPrescriptionListItem };
